const featureContentData_one = {
    heading: "How Ampstekpay Simplifies Contractor Management",
    paragraph: `Managing contractors worldwide is a complex matter. We get it. We know 
      it involves navigating local employment laws, trawling through information on tax systems, 
      and researching payment regulations. With different rules in every country, 
      effective contractor management requires expert knowledge and resources. Enter Ampstekpay.`,
    buttonText: "Speak to our Staffing Experts",
  };
  
  const featureContentData_two = {
    heading: "Global Workforce Management Technology",
    paragraph: `Precision is Ampstekpay’s all-in-one global workforce management platform, designed to simplify the complexities of managing contractors and employees across multiple countries. Precision ensures compliance with local labor laws, tax regulations, and business requirements for any region, making it easier to manage contractors in any country.`,
    buttonText: "",
  };

  const featureEorData_three = {
    heading: "How We Simplify the Employment Process",
    paragraph: `At Ampstekpay, we believe in making global hiring as simple and human as possible.

Our technology platform seamlessly integrates payroll and employment compliance into one easy-to-use system.

Furthermore, you’ll always have a dedicated team of experts to guide you, offering personalised support every step of the way.`,
    buttonText: "",
  }

  const featureContData_three = {
    heading: "How We Simplify the Employment Process",
    paragraph: `At Ampstekpay, we believe in making global hiring as simple and human as possible. Our technology platform seamlessly integrates payroll and employment compliance into one easy-to-use system. Furthermore, you’ll always have a dedicated team of experts to guide you, offering personalised support every step of the way.`,
    buttonText: "",
  }

  const featureStaffingEorData_three = {
    heading: "How Our EOR Service Simplifies the Process",
    paragraph: `Navigating the legal complexities of managing a global workforce can be daunting. However, with Ampstek’s Employer of Record (EOR) service, we take on the burden of compliance, allowing you to focus on what you do best—finding top talent, closing deals, and growing your recruitment business.`,
    buttonText: "",
  }
  const featureStaffingIndependent = {
    heading: "How Ampstekpay Transforms Global Independent Contractor Management ",
    paragraph: `Ampstekpay simplifies global independent contractor management by handling compliance, payroll, onboarding, and offboarding. With our Employer of Record (EOR) services, you can manage contractors seamlessly across multiple regions without the need for local entities, ensuring timely payments and full compliance while you focus on growing your business.`,
    buttonText: "",
  }
  export { featureContentData_one, featureContentData_two ,featureEorData_three ,featureContData_three ,featureStaffingEorData_three,featureStaffingIndependent};